/**
 * Custom application general styles
 */
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * @param {any} props
 * @returns Custom registration card style
 */
export const StyledRegistrationCard = ({ is600Screen, customStyles, children, ...props }) => {
  const defaultStyles = {
    width: is600Screen ? '550px' : '100%',
    height: is600Screen ? '750px' : '100%',
    maxHeight: is600Screen ? '96vh' : '100vh',
    overflowY: 'auto',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: '0px 0px 21px 3px rgba(0, 0, 0, 0.5)',
    borderRadius: is600Screen ? '8px' : 'none',
    padding: '48px 24px',
    textAlign: 'center',
  };

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={3}
      sx={{
        ...defaultStyles,
        ...customStyles,
      }}
    >
      {children}
    </Stack>
  );
};

// StyledRegistrationCard parameter type definition
StyledRegistrationCard.propTypes = {
  is600Screen: PropTypes.bool,
  customStyles: PropTypes.object,
  children: PropTypes.array,
};

/**
 * @param {any} props
 * @returns Custom login card styles
 */
export const StyledLoginCard = ({ is600Screen, is900Screen, customStyles, children, ...props }) => {
  const defaultStyles = {
    width: is600Screen ? '500px' : '100%',
    height: is900Screen ? '100%' : is600Screen ? 'unset' : '100%',
    maxHeight: is900Screen ? '99vh' : '100vh',
    overflowY: 'auto',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: is900Screen ? 'none' : '0px 0px 21px 3px rgba(0, 0, 0, 0.5)',
    borderRadius: is900Screen ? 'none' : is600Screen ? '8px' : 'none',
    padding: '48px 24px',
    paddingTop: is900Screen ? '100px' : '48px',
  };

  return (
    <Stack
      direction="column"
      justifyContent={is900Screen ? 'start' : 'center'}
      alignItems={is900Screen ? 'center' : 'unset'}
      sx={{
        ...defaultStyles,
        ...customStyles,
      }}
    >
      {children}
    </Stack>
  );
};

// StyledLoginCard parameter declarations
StyledLoginCard.propTypes = {
  is600Screen: PropTypes.bool,
  is900Screen: PropTypes.bool,
  customStyles: PropTypes.object,
  children: PropTypes.array,
};
